import { Link } from 'react-router-dom';
import { trackEvent } from '../utils/analytics';

/**
 * Shown right after a successful detection — the moment of highest
 * engagement — to pull detector users into Langle. Ties the pitch to the
 * language they just heard so it reads as a natural next step, not an ad.
 */
export default function LangleAfterDetect({ language }) {
  const lang = typeof language === 'string' ? language.trim() : '';
  return (
    <aside className="langle-after" aria-label="Play Langle">
      <p className="langle-after-kicker">Now try the game</p>
      <p className="langle-after-headline">
        {lang ? `Could you have guessed ${lang} by ear?` : 'Could you guess a language by ear?'}
      </p>
      <p className="langle-after-body">
        Langle plays you a mystery clip. Six tries to name the language, one new puzzle every
        day, about a minute to play.
      </p>
      <div className="langle-after-actions">
        <Link
          to="/langle"
          className="langle-after-cta"
          onClick={() => trackEvent('langle_after_detect_click', lang ? { language: lang } : undefined)}
        >
          Play today's Langle
          <span className="langle-after-arrow" aria-hidden>→</span>
        </Link>
        <span className="langle-after-note">Free · your streak saves to this account</span>
      </div>
    </aside>
  );
}
